import ArrSVG from '@public/icons/btn-arr.svg';
import classNames from 'classnames';
import { useState } from 'react';
import { Question } from '@/entities/question';
import Collapse from '@/shared/components/shared/Collapse';
import Typografed from '@/shared/components/shared/Typografed';
import { tp } from '@/shared/lib/typograf';

export type FaqSectionProps = {
    title: string;
    questions: Question[];
};

type Props = React.HTMLAttributes<HTMLElement> & {
    faqSectionProps: FaqSectionProps;
};

export const SECTION_ID = 'faq';

const FaqSection = ({ faqSectionProps, ...props }: Props) => {
    const [activeIndex, setActiveIndex] = useState(-1);
    return (
        <section
            {...props}
            className={classNames('faq-section js-header-theme-trigger js-bg-trigger', props.className)}
            data-bg="#fff"
            data-theme="dark"
            id={props.id ?? SECTION_ID}
        >
            <div className="faq-section-wrapper wrapper">
                <div className="faq-section-title h3">{faqSectionProps.title}</div>
                <div className="faq-section-content">
                    {faqSectionProps.questions.map(
                        (item, i) =>
                            item.answer && (
                                <Collapse
                                    initialCollapsed
                                    collapsed={activeIndex !== i}
                                    className="faq-section-content-item"
                                    key={i}
                                >
                                    <Collapse.Toggler onClick={() => setActiveIndex(activeIndex === i ? -1 : i)}>
                                        <span className="text-l faq-section-item-title">
                                            <Typografed>{item.question}</Typografed>
                                        </span>
                                        <div className="faq-btn">
                                            <ArrSVG />
                                        </div>
                                    </Collapse.Toggler>
                                    <Collapse.Content>
                                        <div
                                            className="faq-section-answer text-s wysiwyg"
                                            dangerouslySetInnerHTML={{ __html: tp(item.answer) }}
                                        ></div>
                                    </Collapse.Content>
                                </Collapse>
                            ),
                    )}
                </div>
            </div>
        </section>
    );
};

export default FaqSection;
